module.exports = __webpack_public_path__ + "img/dp-sy-lm24.219ecee7.png";